import React, { useEffect, useState } from "react";
import { useLocaleContext } from "../../context/LocaleContext";
import { motion, AnimatePresence } from "framer-motion";
import './style.scss';
import { isFullscreen } from "../Player/FullScreen";

const ZoomHint = () => {
    const { get: getLocale } = useLocaleContext();
    return <div className="hint-zoom-container">
        <div className="hint-zoom-title">{getLocale('hints.zoom.title')}</div>
        <div className="hint-zoom-buttons">
            <span className="hint-zoom-button">↑</span>
            <span className="hint-zoom-str">/</span>
            <span className="hint-zoom-button">↓</span>
        </div>
    </div>
};

const FullScreenHint = () => {
    const { get: getLocale } = useLocaleContext();

    const fullscreen = isFullscreen();

    return (
        <div className="hint-fullscreen-container">
            {getLocale(`hints.fullscreen.title.${fullscreen ? 'exit' : 'enter'}`)}
            <span className={`hint-fullscreen-button ${fullscreen ? 'hint-fullscreen-button-esc' : ''}`}>{fullscreen ? 'Esc' : 'F'}</span>
        </div>
    )
}

const hints = {
    zoom: {
        position: 'bottom',
        element: <ZoomHint />
    },
    fullscreen: {
        position: 'top',
        element: <FullScreenHint />
    },
}

export default ({ type, animationType = 'sliding', position, duration, }) => {

    const [open, setOpen] = useState(!!hints[type]);

    useEffect(() => {
        let timeout;

        if ((duration || animationType === 'hiding') && open) {
            timeout = setTimeout(() => {
                setOpen(false);
            }, duration || 2000);
        }

        return () => clearTimeout(timeout);
    }, [])

    useEffect(() => {
        let timeout;

        const mousemoveListener = () => {
            setOpen(true);
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                setOpen(false);
            }, 2000);
        }

        if (animationType === 'hiding') {
            document.addEventListener('mousemove', mousemoveListener);
        } else {
            clearTimeout(timeout);
            document.removeEventListener('mousemove', mousemoveListener);
        }

        return () => {
            document.removeEventListener('mousemove', mousemoveListener);
            clearTimeout(timeout);
        };
    }, [animationType])

    const _position = position || hints[type]?.position || "bottom";

    const initial = {
        sliding: {
            x: "-50%",
            y: _position === "bottom" ? 50 : -50,
            opacity: 0,
        },
        hiding: {
            x: "-50%",
            opacity: 0,
        },
    };

    const animate = {
        sliding: {
            x: "-50%",
            y: 0,
            opacity: 1,
        },
        hiding: {
            x: "-50%",
            opacity: 1,
        },
    };

    const exit = {
        sliding: {
            x: "-50%",
            y: _position === "bottom" ? 50 : -50,
            opacity: 0,
        },
        hiding: {
            x: "-50%",
            opacity: 0,
        },
    };

    const transition = {
        duration: {
            sliding: 1,
            hiding: 0.5,
        }
    }

    return <AnimatePresence>
        {open && <motion.div
            className={`hint-container position-${_position === "bottom" ? "bottom" : "top"}`}
            initial={initial[animationType]}
            animate={animate[animationType]}
            exit={exit[animationType]}
            transition={{ duration: transition.duration[animationType] / (open ? 2 : 1) }}
        >{hints[type]?.element}</motion.div>}
    </AnimatePresence>
}